const config = {
  ENVIRONMENT: process.env.ENV || 'testing',
  OPTIMIZELY_SDK_KEY: process.env.OPTIMIZELY_SDK_KEY || '49ZkmCj1we5AX8GuThQGpJ',
  OPTIMIZELY_LOG_LEVEL: process.env.OPTIMIZELY_LOG_LEVEL || 'info',
  SENTRY_DSN: process.env.SENTRY_DSN,
  SENTRY_RELEASE: process.env.SENTRY_RELEASE,
  SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT || 'development',
  LIBRARY_API_DOMAIN: process.env.LIBRARY_API_DOMAIN || '', // allow override for testing
  CHECKOUT_API_URL: process.env.CHECKOUT_API_URL || 'https://i2w72pabt6.execute-api.us-east-1.amazonaws.com/testing',
  SERVICES_URL: process.env.SERVICES_URL || 'https://services-test.sparkol-dev.co.uk',
  TERMS_URL: process.env.TERMS_URL || 'https://help.sparkol.com/support/solutions/folders/1000218934',
  PRIVACY_URL:
    process.env.PRIVACY_URL || 'https://help.sparkol.com/support/solutions/articles/1000033746-privacy-statement',
  RECAPTCHA_SITEKEY: process.env.RECAPTCHA_SITEKEY || 'recaptchasitekey',
  TUTORIAL_URL:
    process.env.TUTORIAL_URL || 'https://player.vimeo.com/video/571189025?autoplay=1&title=0&byline=0&portrait=0',
  GA_ACCOUNT_ID: process.env.GA_ACCOUNT_ID || 'development',
  HUBSPOT_ID: process.env.HUBSPOT_ID,
  APPLICATION_NAME: process.env.APPLICATION_NAME || 'scribely',
  LOQATE_FIND_URL:
    process.env.LOQATE_FIND_URL || '//services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws',
  LOQATE_RETRIEVE_URL:
    process.env.LOQATE_RETRIEVE_URL ||
    'https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws',
  LOQATE_KEY: process.env.LOQATE_KEY,
  TEMPLATE_CREATOR_EMAILS: process.env.TEMPLATE_CREATOR_EMAILS,
  MANAGE_ACCOUNT_URL: process.env.MANAGE_ACCOUNT_URL || 'https://videoscribecloud.dev.sparkol-dev.co.uk/account',
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_SPACE_ID,
  CONTENTFUL_ENVIRONMENT: process.env.CONTENTFUL_ENVIRONMENT,
  CONTENTFUL_CDN_TOKEN: process.env.CONTENTFUL_CDN_TOKEN,
  CONTENTFUL_OAUTH_URL: 'https://be.contentful.com/oauth/authorize',
  CONTENTFUL_OAUTH_CLIENT_ID: process.env.CONTENTFUL_OAUTH_CLIENT_ID,
  USERSNAP_KEY: process.env.USERSNAP_KEY,
  USERSNAP_SURVEY_KEY: process.env.USERSNAP_SURVEY_KEY,
  MIXPANEL_API_TOKEN: process.env.MIXPANEL_API_TOKEN,
  DEBUG_MIXPANEL: process.env.DEBUG_MIXPANEL,
  THUMB_SIZE: '140',
  SERVICES_REQUEST_RATE_LIMIT: 6,
  SERVICES_REQUEST_CONCURRENCY: 2,
  MAX_AUDIO_RECORD_TIME_MS: process.env.MAX_AUDIO_RECORD_TIME_MS || 20 * 60 * 1000,
  PRICING_URL: process.env.PRICING_URL,
  TEMPLATE_LIBRARY_URL: process.env.TEMPLATE_LIBRARY_URL,
  FAQ_URL: process.env.FAQ_URL,
  BLOG_URL: process.env.BLOG_URL,
  CONTACT_US_URL: process.env.CONTACT_US_URL,
  SPARKOL_URL: process.env.SPARKOL_URL,
  FACEBOOK_URL: process.env.FACEBOOK_URL,
  LINKEDIN_URL: process.env.LINKEDIN_URL,
  TWITTER_URL: process.env.TWITTER_URL,
  HUBSPOT_NEWSLETTER_REGION: process.env.HUBSPOT_NEWSLETTER_REGION,
  HUBSPOT_NEWSLETTER_FORM_ID: process.env.HUBSPOT_NEWSLETTER_FORM_ID,
  HUBSPOT_NEWSLETTER_PORTAL_ID: process.env.HUBSPOT_NEWSLETTER_PORTAL_ID,
  COGNITO_CLIENT_ID: process.env.COGNITO_CLIENT_ID,
  AWS_REGION: 'us-east-1'
};

export default config;

export const LOCATION_SESSION_STORAGE_KEY = 'Scribe_location';
export const FREE_DOWNLOAD_LIMIT = 30;
export const GRID_SIZE = 30;
export const E2E_GEN_TEST_USER_PREFIX = 'auto-test-user';
export const E2E_GEN_TEST_USER_SUFFIX = '@sparkol.com';
export const CROPPABLE_IMAGE_TYPES = ['image/png', 'image/jpg', 'image/bmp', 'image/svg+xml'];
export const CROP_SHAPE_TYPES = {
  RECTANGLE: 'RECTANGLE',
  SQUARE: 'SQUARE',
  CIRCLE: 'CIRCLE',
  ELLIPSE: 'ELLIPSE'
};

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,100}$/;
export const MIN_PASSWORD_LENGTH = 8;
export const REPORT_A_BUG_URL = process.env.REPORT_A_BUG_URL;
export const REQUEST_A_FEATURE_URL = process.env.REQUEST_A_FEATURE_URL;
export const APPLICATION_DISPLAY_NAME = process.env.APPLICATION_DISPLAY_NAME || 'Scribely';
